import React, { useState } from "react";
import { motion } from "motion/react";

interface TeamCardProps {
  name: string;
  role: string;
  image: string;
  description: string;
  bgColor: string;
  roleColor?: string;
}

const TeamCard = ({
  name,
  role,
  image,
  description,
  bgColor,
  roleColor,
}: TeamCardProps) => {
  const [isFlipped, setIsFlipped] = useState(false);
  return (
    <div
      className="w-[294px] h-[360px] perspective cursor-pointer"
      onClick={() => setIsFlipped((prev) => !prev)}
    >
      <motion.div
        className="relative w-full h-full"
        animate={{ rotateY: isFlipped ? 180 : 0 }}
        whileHover={{ rotateY: 180 }}
        transition={{ duration: 0.8, ease: "easeInOut" }}
        style={{ transformStyle: "preserve-3d" }}
      >
        <div className="absolute w-full h-full backface-hidden rounded-xl bg-[#76C6F2] overflow-hidden shadow-lg">
          {name !== "Shola Adeniyi" && (
            <img
              src={image}
              alt={name}
              className="w-full h-full object-cover"
            />
          )}

          <div
            className={`absolute bottom-0 w-full p-4 text-left z-10 ${roleColor === "white" ? "text-ashShade-17" : "text-blueShades-4"}`}
          >
            <h3 className="text-lg ">{name}</h3>
            <p className="text-sm ">{role}</p>
          </div>
        </div>

        <div
          className={`absolute w-full h-full backface-hidden rounded-xl p-5 flex flex-col gap-4 ${bgColor === "dark" ? "bg-blueShades-6" : "bg-blueShades-7"} `}
          style={{ transform: "rotateY(180deg)" }}
        >
          <div>
            <h3
              className={`text-lg ${bgColor === "dark" ? "text-blueShades-7" : "text-blueShades-4"}`}
            >
              {name}
            </h3>
            <p
              className={`text-sm ${bgColor === "dark" ? "text-blueShades-7" : "text-blueShades-4"}`}
            >
              {role}
            </p>
          </div>

          <p
            className={`text-base ${bgColor === "dark" ? "text-blueShades-7" : "text-blueShades-4"} `}
          >
            {description}
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default TeamCard;
